/* eslint-disable quotes */

import { minBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import switchModal from '@/components/generics/modal/switch/switch.vue';

const csvPrefix = 'data:text/csv;charset=utf-8,';
const csvHeader = 'Market Outcome,Type,Shares,Avg Price,Share Value,If Yes,If No,Risk,Payout';
const csvInfoOne = `"Your Risk in any contract is the sum of your profits and losses, across all contracts, should that contract resolve to 'Yes'. To work out this sum, add the 'If Yes' figure for the contract to the 'If No' figures for all other contracts."`;
const csvInfoTwo = '"Your Investment in the market as a whole is equal to your greatest Risk in any one contract. This is the amount PredcitIt debits from your account to cover your position."';
const csvInfoThree = '"Your Payout is the amount you would be credited if the contract resolves to Yes. It is the difference between your total Investment (greatest Risk) and the Risk in the winning contract."';
const csvInfoFour = '"Share Value corresponds to the face value of your position in each contract (shares multiplied by average purchase price)."';

function predictionTypeToString(type) {
  return type === 0 || type === 2 ? 'No' : 'Yes';
}
function formatData(o) {
  return o < 0 ? `($${Math.abs(o).toFixed(3)})` : `$${o.toFixed(3)}`;
}
const COLUMNS = ['averagePrice', 'investment', 'profitYes', 'profitNo', 'riskAmount', 'payoutAmount'];
const COLUMNS_LAST = COLUMNS.slice(1);
function csvObjectToString(o, i, c) {
  if (i + 1 === c.length) {
    const formatedData = COLUMNS_LAST.map(prop => formatData(o[prop]));
    return `${o.contractName},,,,${formatedData.join(',')}`;
  }
  const type = predictionTypeToString(o.predictionType);
  const formatedData = COLUMNS.map(prop => formatData(o[prop]));
  return `${o.contractName},${type},${o.sharesOwned},${formatedData.join(',')}`;
}

function toCsv(contractsArray, filename, link) {
  const arr = contractsArray.map(csvObjectToString);

  if (window.navigator.msSaveBlob) {
    const IE = new Blob([`${csvHeader}\n${arr.join('\n')}\n\n\n${csvInfoOne}\n${csvInfoTwo}\n${csvInfoThree}\n${csvInfoFour}`],
                        { type: 'text/csv;charset=utf-8' });
    window.navigator.msSaveBlob(IE, filename);
  } else {
    let data;
    if (window.Blob) {
      const csvNoPrefix = `${csvHeader}\n${arr.join('\n')}\n\n\n${csvInfoOne}\n${csvInfoTwo}\n${csvInfoThree}\n${csvInfoFour}`;
      const blob = new Blob([csvNoPrefix], { type: 'text/csv;charset=utf-8' });
      data = window.URL.createObjectURL(blob);
    } else {
      const csv = `${csvPrefix}${csvHeader}\n${arr.join('\n')}\n\n\n${csvInfoOne}\n${csvInfoTwo}\n${csvInfoThree}\n${csvInfoFour}`;
      data = encodeURI(csv);
    }
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
  }
}

export default {
  components: {
    switchModal,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toggleIndex: 1,
      faqlink: {
        name: 'Faq',
        params: { faqid: 666 },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('profile', ['marketPayouts']),
    itemWithGreatestRisk() {
      return minBy(this.payouts, x => x.riskAmount);
    },
    payouts() {
      return this.marketPayouts === null ? [] : this.marketPayouts.contracts;
    },
    showSpinner() {
      return this.payouts.length === 0;
    },
    classModifier() {
      return {
        'potential-payouts__content--long': this.payouts.length > 5,
      };
    },
  },
  methods: {
    ...mapActions('overlay', { hideOverlay: 'hide' }),
    ...mapActions('profile', ['getMarketPayouts', 'clearMarketPayouts']),
    isNo(item) {
      return (item.predictionType === 0 || item.predictionType === 2);
    },
    yourOwnText(item) {
      return predictionTypeToString(item.predictionType);
    },
    yourOwnModifiers(item) {
      const isNo = this.isNo(item);
      return {
        'potential-payouts--bar': true,
        'potential-payouts--no': isNo,
        'potential-payouts--yes': !isNo,
      };
    },
    isWithGreatestRisk(item) {
      if (!this.itemWithGreatestRisk) return false;
      return item.riskAmount === this.itemWithGreatestRisk.riskAmount;
    },
    toggle() {
      this.toggleIndex += 1;
    },
    close() {
      this.$emit('modalClose');
    },
    whileRouting() {
      this.$emit('modalClose');
      this.hideOverlay();
    },
    onExport() {
      toCsv(this.marketPayouts.contracts, `Potential Payouts-${this.market.marketId}.csv`, this.$refs.export);
    },
  },
  mounted() {
    this.getMarketPayouts(this.market.marketId);
  },
  beforeDestroy() {
    this.clearMarketPayouts();
  },
};



// WEBPACK FOOTER //
// ./src/components/potential-payouts/potential-payouts.js